export default function ServiceInfoDisplay({ selectedService }) {
  if (!selectedService) return null;

  const serviceName = selectedService.service_name || selectedService.name;
  const duration = selectedService.total_duration_minutes || selectedService.duration_minutes;
  const price = selectedService.base_price || selectedService.price || 0;

  return (
    <div className="p-4 bg-blue-50 rounded-lg">
      <h3 className="font-semibold text-blue-900">{serviceName}</h3>
      <p className="text-sm text-blue-700 mt-1">
        Duration: {duration} minutes
      </p>
      <p className="text-sm text-blue-700">Price: ${price}</p>
    </div>
  );
}